import {NgModule} from '@angular/core';
import {ChipWrapperComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {CommonModule, NgTemplateOutlet} from '@angular/common';
import {ChipComponentModule} from '../chip/item.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ChipComponentModule,
    NgTemplateOutlet
  ],
  exports: [
    ChipWrapperComponent
  ],
  declarations: [ChipWrapperComponent],
  providers: [],
})
export class ChipWrapperComponentModule {
}
